/** The objects three draws with a geometry and a material: a mesh, a line or points. */
/**
 * Whether `object` is a mesh, a line or points. Line segments and a line loop are lines.
 *
 * @canonical Whether an object is a mesh, a line or points
 */
export function isDrawable(object) {
    const { isMesh, isLine, isPoints } = object;
    return isMesh === true || isLine === true || isPoints === true;
}
//# sourceMappingURL=drawable.js.map